module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal-2l"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("To Frank and Ruth Osborne. Much of my life and ministry is the result of their prayers. They not only prayed for me but also provided me with my most-needed answer to prayer, their daughter as my wife!—Gerald")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-l"
  }, [_c('span', [_vm._v("I write this in hopes that my children and those who read this will learn to pray effective kingdom prayers.—Bob")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 63
// module chunks = 0